export const customStyles = {
  control: (styles: any) => ({
    ...styles,
    cursor: "pointer",
    outline: "none",
    boxShadow: "none",
  }),
};
